import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Building, Shield, Briefcase, User } from 'lucide-react';

const ClientUserSummary = ({ clients, users }) => {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-lg">
          <Building className="w-5 h-5 text-emerald-600" />
          Client-User Assignment Overview
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-h-[300px] overflow-y-auto">
          {clients.map(client => {
            const assignedUsers = users.filter(u => 
              u.role !== 'admin' && u.assigned_client_ids?.includes(client.id)
            );
            const adminUsers = users.filter(u => u.role === 'admin');
            
            return (
              <div 
                key={client.id} 
                className="p-3 border rounded-lg bg-slate-50 hover:bg-slate-100 transition-colors"
                data-testid={`client-summary-${client.id}`}
              >
                <div className="flex items-center gap-2 mb-2">
                  <Building className="w-4 h-4 text-emerald-600" />
                  <span className="font-medium text-sm truncate" title={client.name}>
                    {client.name}
                  </span>
                </div>
                <div className="space-y-1">
                  {adminUsers.length > 0 && (
                    <div className="flex flex-wrap gap-1">
                      {adminUsers.slice(0, 2).map(admin => (
                        <Badge key={admin.id} className="text-xs bg-red-100 text-red-700">
                          <Shield className="w-2 h-2 mr-1" />
                          {admin.full_name?.split(' ')[0] || admin.email.split('@')[0]}
                        </Badge>
                      ))}
                      {adminUsers.length > 2 && (
                        <Badge className="text-xs bg-red-100 text-red-700">
                          +{adminUsers.length - 2}
                        </Badge>
                      )}
                    </div>
                  )}
                  {assignedUsers.length > 0 ? (
                    <div className="flex flex-wrap gap-1">
                      {assignedUsers.map(user => (
                        <Badge 
                          key={user.id} 
                          variant="outline" 
                          className={`text-xs ${user.role === 'employee' ? 'bg-blue-50 text-blue-700 border-blue-200' : 'bg-slate-100 text-slate-600'}`}
                        >
                          {user.role === 'employee' && <Briefcase className="w-2 h-2 mr-1" />}
                          {user.role === 'customer' && <User className="w-2 h-2 mr-1" />}
                          {user.full_name?.split(' ')[0] || user.email.split('@')[0]}
                        </Badge>
                      ))}
                    </div>
                  ) : (
                    <span className="text-xs text-slate-400">No specific assignments</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        {clients.length === 0 && (
          <p className="text-center text-slate-500 py-4">No clients found</p>
        )}
      </CardContent>
    </Card>
  );
};

export default ClientUserSummary;
